import React from "react";
import { graphql } from "gatsby";

import Layout from "../components/Layout";
import Seo from "../components/seo";
import AboutSection from "../components/home/AboutSection";
import Services from "../components/home/Services";
import RecentProjects from "../components/home/RecentProjects";
import ContactSection from "../components/home/ContactSection";

const Home = ({ data }) => {
  const { prismicHomepage, allPrismicServicios, allPrismicProyectos } = data;
  const aboutSection = prismicHomepage.data.about_section[0];
  const contactSection = prismicHomepage.data.contact_section[0];

  return (
    <Layout>
      <Seo title={prismicHomepage.data.title.text} />
      <AboutSection
        words={aboutSection.words.text}
        copy={aboutSection.copy.text}
        content={aboutSection.content.raw}
        image={aboutSection.image}
      />
      <Services services={allPrismicServicios.nodes} />
      <RecentProjects projects={allPrismicProyectos.nodes} />
      <ContactSection
        images={{ left: contactSection.image_1, right: contactSection.image_2 }}
      />
    </Layout>
  );
};

export const query = graphql`
  query($language: String!) {
    prismicHomepage(lang: { eq: $language }) {
      data {
        title {
          text
        }
        about_section {
          words {
            text
          }
          copy {
            text
          }
          content {
            raw
          }
          image {
            alt
            localFile {
              childImageSharp {
                gatsbyImageData
              }
            }
          }
        }
        contact_section {
          image_1 {
            alt
            localFile {
              childImageSharp {
                gatsbyImageData
              }
            }
          }
          image_2 {
            alt
            localFile {
              childImageSharp {
                gatsbyImageData
              }
            }
          }
        }
      }
    }
    allPrismicServicios(filter: { lang: { eq: $language } }) {
      nodes {
        data {
          title {
            text
          }
        }
        uid
      }
    }
    allPrismicProyectos(filter: { lang: { eq: $language } }, limit: 3) {
      nodes {
        data {
          title {
            text
          }
          cover {
            localFile {
              childImageSharp {
                gatsbyImageData
              }
            }
          }
        }
        uid
      }
    }
  }
`;

export default Home;
